
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/type/[type]",
      function () {
        return require("private-next-pages/news/type/[type].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/type/[type]"])
      });
    }
  